import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CatalogItemVendorBadgeSlots = {
  PRIMARY: 'primary',
  FULFILLMENT: 'fulfillment',
  SUSTAINABILITY: 'sustainability',
  DEAL: 'deal',
} as const

export type CatalogItemVendorBadgeSlotEnum = Enum<
  typeof CatalogItemVendorBadgeSlots
>
